"use client";

import React from "react";
import styles from "./CasesGrid.module.scss";
import { useLocale } from "next-intl";
import { CasesItem } from "@/components/Home/Cases/CasesItem";

interface ICase {
  id: number;
  title: string;
  description: string;
  images: string[];
  type: string[];
  backgroundColor: string;
  slug: string;
}

interface ICasesGrid {
  projects: ICase[];
  handleCaseHover?: (side: string) => void;
}

export default function CasesGrid({ projects, handleCaseHover }: ICasesGrid) {
  const locale = useLocale();
  const getProjectHref = (slug: string) =>
    locale === "en" ? `/en/projects/${slug}` : `/proyectos/${slug}`;

  if (!projects || projects.length === 0) return null;

  return (
    <section className={styles.wrapper}>
      {projects.map((item: ICase, index) => (
        <CasesItem
          key={item.id}
          item={item}
          chips={item.type}
          href={getProjectHref(item.slug)}
          titleAs="h2"
          handleHover={
            handleCaseHover
              ? () => handleCaseHover(index % 2 === 0 ? "left" : "right")
              : undefined
          }
        />
      ))}
    </section>
  );
}
